export default "<app-detail-form [uid] = 'uid' [screenHandler] = 'screenHandler' [screenDescriptor] = 'screenStructure'></app-detail-form>";